/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Factual_Slug_WalkInputs */

const en_light_factual_slug_walk = /** @type {(inputs: Light_Factual_Slug_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Light_Factual_Slug_WalkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const light_factual_slug_walk = /** @type {((inputs?: Light_Factual_Slug_WalkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Factual_Slug_WalkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_light_factual_slug_walk(inputs)
});